import { H4 } from 'foundations-components/transitional/components/H4';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Section } from 'foundations-components/transitional/components/Section';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ForbiddenPage = ({
  RhumbMarker = null
}) => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    children: /*#__PURE__*/_jsx(Section, {
      use: "island",
      children: /*#__PURE__*/_jsx(ErrorMessage, {
        illustration: "lock",
        illustrationProps: {
          width: 200
        },
        title: /*#__PURE__*/_jsx(H4, {
          marginBlockEnd: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "forbiddenPage.title"
          })
        }),
        children: /*#__PURE__*/_jsxs("p", {
          children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
            "data-selenium-test": "error-message",
            message: "forbiddenPage.body"
          }), RhumbMarker]
        })
      })
    })
  });
};